// Makes a booking form. Gets clicked in the reservation email sent to our gmail
// For testing: localhost:3000/#/bookingform?lastName=Smith&firstName=leptest&streetAddress=51%20red%20street&postalCode=N0H%202R0&country=Canada&phoneNumber=000-000-0000&email=nickpsotka@outlook.com&numAdults=2&numChildren=0&childrenAges=&campingUnit=Travel%20Trailer&campingUnitLength=14&arrivalDate=Mon%20Sep%2007%202026&departureDate=Sat%20Sep%2012%202026&numNights=5&checkInTime=&siteType=Unserviced&backupSiteType=&extraCar=False&screenTentOrDiningTent=False&numElectricVehicles=1&extraInfo=

import { useEffect, useState } from "react";

export const BookingForm = () => {
  //get the attributes from the url
  useEffect(() => {
    const params = Object.fromEntries(
      new URLSearchParams(window.location.search).entries(),
    );

    setReservation((prev) => ({ ...prev, ...params }));
  }, []);

  const [reservation, setReservation] = useState({
    lastName: "",
    firstName: "",
    streetAddress: "",
    postalCode: "",
    country: "",
    phoneNumber: "",
    email: "",
    numAdults: "",
    numChildren: "",
    childrenAges: "",
    campingUnit: "",
    campingUnitLength: "",
    arrivalDate: "",
    departureDate: "",
    numNights: "",
    checkInTime: "",
    siteType: "",
    backupSiteType: "",
    extraCar: "",
    screenTentOrDiningTent: "",
    numElectricVehicles: "",
    extraInfo: "",
  });

  const [enteredBy, setEnteredBy] = useState("");
  const [resNumber, setResNumber] = useState("");
  const [receivedBy, setReceivedBy] = useState("");
  const [printSide, setPrintSide] = useState("left");

  const today = new Date().toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });

  //fill in Entered by and Rec'd by fields from localstorage
  useEffect(() => {
    const operatorName = localStorage.getItem("operator_name");
    if (operatorName) {
      setEnteredBy(operatorName);
      setReceivedBy(operatorName);
    }
  }, []);

  return (
    <div className="page booking-summary-compact">
      <div
        className="booking-form-container"
        style={{
          marginLeft: printSide === "right" ? "52%" : "0",
        }}
      >
        <div className="print-side-buttons">
          <button onClick={() => setPrintSide("left")}>Left Side</button>

          <button onClick={() => setPrintSide("right")}>Right Side</button>
        </div>
        {/* ================= HEADER TABLE ================= */}
        <table className="booking-summary-table">
          <colgroup>
            <col style={{ width: "15%" }} /> {/* first column (smaller) */}
            <col style={{ width: "28%" }} /> {/* RES column (larger) */}
            <col style={{ width: "12%" }} />
            <col style={{ width: "21%" }} />
            <col style={{ width: "24%" }} /> {/* DATE spans last 2 */}
          </colgroup>
          <tbody>
            <tr>
              <td>
                <div className="booking-summary-cell">
                  <label>ENTERED BY</label>
                  <input
                    value={enteredBy}
                    onChange={(e) => setEnteredBy(e.target.value)}
                    onBlur={(e) =>
                      localStorage.setItem(
                        "operator_name",
                        e.target.value.trim(),
                      )
                    }
                  />
                </div>
              </td>
              <td className="res-cell">
                <div className="booking-summary-cell">
                  <label>RES #</label>
                  <input
                    value={resNumber}
                    onChange={(e) => setResNumber(e.target.value)}
                  />
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <div className="booking-summary-cell">
                  <label>REC'D BY</label>
                  <input
                    value={receivedBy}
                    onChange={(e) => setReceivedBy(e.target.value)}
                    onBlur={(e) =>
                      localStorage.setItem(
                        "operator_name",
                        e.target.value.trim(),
                      )
                    }
                  />
                </div>
              </td>
              <td>
                <div className="booking-summary-cell">
                  <label>NEW</label>
                  <div className="booking-summary-static">✓</div>
                </div>
              </td>
              <td>
                <div className="booking-summary-cell">
                  <label>CHANGE</label>
                  <div className="booking-summary-static" />
                </div>
              </td>

              <td>
                <div className="booking-summary-cell">
                  <label>CANCEL</label>
                  <div className="booking-summary-static" />
                </div>
              </td>
              <td colSpan={2}>
                <div className="booking-summary-cell">
                  <label>DATE</label>
                  <div className="booking-summary-static">{today}</div>
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <div className="booking-summary-cell">
                  <label>REQUESTED</label>
                  <input />
                </div>
              </td>
              <td>
                <div className="booking-summary-cell">
                  <label>ALLOCATED</label>
                  <input />
                </div>
              </td>
              <td>
                <div className="booking-summary-cell">
                  <label>ADVISED</label>
                  <input />
                </div>
              </td>
              <td>
                <div className="booking-summary-cell">
                  <label>DEPOSIT</label>
                  <input />
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        {/* ================= DETAILS (PLAIN TEXT) ================= */}
        <div className="booking-details">
          <p>Last Name: {reservation.lastName}</p>
          <p>First Name: {reservation.firstName}</p>
          <p>Street Address: {reservation.streetAddress}</p>
          <p>Postal Code: {reservation.postalCode}</p>
          <p>Country: {reservation.country}</p>
          <p>Phone Number: {reservation.phoneNumber}</p>
          <p>Email: {reservation.email}</p>
          <p>Number of Adults: {reservation.numAdults}</p>
          <p>Number of Children: {reservation.numChildren}</p>
          <p>Children Ages: {reservation.childrenAges}</p>
          <p>Camping Unit: {reservation.campingUnit}</p>
          <p>Length in Feet: {reservation.campingUnitLength}</p>
          <p>Arrival Date: {reservation.arrivalDate}</p>
          <p>Departure Date: {reservation.departureDate}</p>
          <p>Number of Nights: {reservation.numNights}</p>
          <p>Estimated Time of Check-in: {reservation.checkInTime}</p>
          <p>Type of Campsite: {reservation.siteType}</p>
          <p>Alternate: {reservation.backupSiteType}</p>
          <p>Extra Car: {reservation.extraCar}</p>
          <p># EV: {reservation.numElectricVehicles}</p>
          <p>Dining Tent / Screen Tent: {reservation.screenTentOrDiningTent}</p>
          <div className="extra-info-field">
            <label>Extra Info: </label>
            <textarea
              value={reservation.extraInfo || ""}
              onChange={(e) =>
                setReservation((prev) => ({
                  ...prev,
                  extraInfo: e.target.value,
                }))
              }
              rows={8}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
